import React, { useState } from "react";
import { Button } from "../ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";

const ExpandSection = ({
  title,
  children,
  initiallyExpanded = true,
}: {
  title: string;
  initiallyExpanded?: boolean;
  children: React.ReactNode;
}) => {
  const [expanded, setExpanded] = useState(initiallyExpanded);

  return (
    <div className="mt-8">
      <div
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between border border-black rounded-lg px-4 py-2 bg-white"
      >
        <span className="text-sm text-black">{title}</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setExpanded(!expanded)}
          className="p-1"
        >
          {expanded ? (
            <ChevronUp className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )}
        </Button>
      </div>

      {expanded && children}
    </div>
  );
};

export default ExpandSection;
